var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('inputTextarea',{attrs:{"data":_vm.data.text,"label":_vm.$t('design.info.description.text'),"callback":function(value) {
        _vm.setValue(value);
      },"error":false,"styling":{ input: 'width: 100%; max-width: 100%; display: block' }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }